wbApp.controller('EmployeesDetailCtrl', ['$scope', '$timeout', '$translate', 'employeeSvc', 'notificationSvc', 'picturesSvc', 'tenantInfo', 'tenantSettingSvc',
function ($scope, $timeout, $translate, employeeSvc, notificationSvc, picturesSvc, tenantInfo, tenantSettingSvc) {

    $scope.isFranchise = tenantInfo.franchiseCentrals.length > 0;
    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;

    var defaultCroppedImage = 'data:image/png;base64,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';
    $scope.emptyImage = 'https://gaxb7o2ddx-images.storage.googleapis.com/Profile/0/cf2830ffb3df4d72a4cbbc8f88fa3c8a.png';

    $scope.img = {
        image: '',
        croppedImage: defaultCroppedImage
    }

    $scope.enableZoomIntegration = tenantSettingSvc.settings.enableZoomIntegration;

    $scope.onImageLoadSuccess = function () {
        $scope.imageIsValid = true;
    }

    $scope.onImageLoadError = function () {
        $scope.imageIsValid = false;
        notificationSvc.notifyError(
            $translate.instant('TXT_ALERT_ERROR_LOADING_IMAGE'),
            $translate.instant('TXT_ALERT_UNSUPPORTED_IMAGE_TYPE'));
    }

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "users/employees/employees-detail-main-tab.html",
            type: 'main'
        },
        {
            title: "TXT_LBL_ADITIONAL",
            template: "users/employees/employees-detail-aditional-tab.html",
            type: 'aditional'
        },
        {
            title: "TXT_LBL_PUBLIC",
            template: "users/employees/employees-detail-public-tab.html",
            type: 'public'
        },
        {
            title: "TXT_LBL_PICTURE",
            template: "users/employees/employees-detail-picture-tab.html",
            type: 'picture'
        }        
    ];

    if ($scope.isFranchise) {
        $scope.detailTabs.push({
            title: "TXT_LBL_FRANCHISE_LICENSES",
            template: "users/employees/employees-detail-franchise-licenses-tab.html",
            type: 'franchise'
        });
    }

    if (tenantSettingSvc.settings.enableReservationSupport)
    {
        $scope.detailTabs.push({
            title: "TXT_SPECIALIZATIONS",
            template: "users/employees/employees-detail-domains-tab.html",
            type: 'domains'
        });
    }

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailTabs.activeTab = 0;

    var domainsInitialized = false;

    $scope.employeeDomains = null;

    var treeListInstance = null;
    $scope.domainsOptions = {
        bindingOptions: {
            dataSource: 'employeeDomains',
        },
        height: 400,
        dataStructure: 'tree',
        keyExpr: 'id',
        itemsExpr: 'specializations',
        selection: {
            mode: 'multiple',           
            recursive: false
        },
        showRowLines: true,
        allowColumnResizing: true,
        autoExpandAll: true,
        columns: [{
            caption: 'Name',
            dataField: 'name',
            dataType: 'string',
            width: '220px'
        }, {
            caption: 'Popis',
            dataField: 'description',
            dataType: 'string'
        }],
        onContentReady: function (e) {
            treeListInstance = e.component;
            if (!!origDomainsSelected) {
                treeListInstance.selectRows(origDomainsSelected, false);
            }
        },
        onSelectionChanged: function (e) {
            if (e.currentSelectedRowKeys.length == 1) {
                var obj = _.find(e.selectedRowsData, { id: e.currentSelectedRowKeys[0] });
                if (obj && obj.parentId) {
                    treeListInstance.selectRows(obj.parentId, true);
                }
            } else if (e.currentDeselectedRowKeys.length == 1) {
                var obj = _.find(e.selectedRowsData, { parentId: e.currentDeselectedRowKeys[0] });
                if (obj) {
                    treeListInstance.selectRows(e.currentDeselectedRowKeys[0], true);
                }
            }
        }
    };

    var origDomainsSelected = [];

    function loadDomainsData() {

        employeeSvc.loadDomainsData($scope.model.employeeID).then(function (data) {
            $scope.employeeDomains = data.domains;
            origDomainsSelected = data.selection;
            if (!!treeListInstance) {
                treeListInstance.selectRows(origDomainsSelected, false);
            }
            domainsInitialized = true;
        });
    }

    $scope.$watch('detailTabs.activeTab', function (newValue, oldValue) {
        if (newValue >= 0 && newValue < $scope.detailTabs.length) {
            var selectedTab = $scope.detailTabs[newValue];

            if (selectedTab.type == 'domains' && !domainsInitialized) {
                loadDomainsData();
            }
        }
    });

    function domainsAreUnchanged() {
        return !domainsInitialized || !treeListInstance ||
               (!!domainsInitialized && (_.isEqual(origDomainsSelected.sort(), treeListInstance.getSelectedRowKeys().sort())));
    }

    function detailIsUnchanged(data) {
        return angular.equals(data, $scope.modelOrig);
    }

    $scope.detailIsUnchanged = function (data) {
        return detailIsUnchanged(data) && !$scope.imageIsValid && domainsAreUnchanged();
    };

    $scope.isDeletePictureDisabled = function () {
        return ($scope.emptyImage === $scope.model.smallImageUrl);
    }

    $scope.onDeletePicture = function () {
        $scope.imageIsValid = false;
        $scope.img.image = null;
        $scope.img.croppedImage = defaultCroppedImage;
        if (!$scope.model.smallImageData) {
            $scope.model.smallImageData = {};
        }
        $scope.model.smallImageData.delete = true;
        $scope.model.smallImageUrl = $scope.emptyImage;
    }

    $scope.isSaving = false;


    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        function success() {
            $scope.$hide();
            $scope.onSave();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        if (!detailIsUnchanged($scope.model)) {

            if ($scope.imageIsValid) {
                var originalFormat = picturesSvc.decodeImageTypeFromData($scope.img.image);
                model.smallImageData = picturesSvc.prepareImageData($scope.img.croppedImage, originalFormat, error);
                if (!model.smallImageData) {
                    return;
                }
            }

            if (!model.employeeID) {
                employeeSvc.insert(model, function (data) {
                    if (!domainsAreUnchanged()) {
                        employeeSvc.saveDomainsData(
                            data.employeeID,
                            $scope.employeeDomains,
                            origDomainsSelected,
                            treeListInstance.getSelectedRowKeys(),
                            success,
                            error);
                    } else {
                        success();
                    }
                }, error, $scope.collection);
            } else {
                employeeSvc.update(model, function () {
                    if (!domainsAreUnchanged()) {
                        employeeSvc.saveDomainsData(
                            $scope.model.employeeID,
                            $scope.employeeDomains,
                            origDomainsSelected,
                            treeListInstance.getSelectedRowKeys(),
                            success,
                            error);
                    } else {
                        success();
                    }
                }, error, $scope.collection);
            }
        } else if (!domainsAreUnchanged()) {
            employeeSvc.saveDomainsData(
                $scope.model.employeeID,
                $scope.employeeDomains,
                origDomainsSelected,
                treeListInstance.getSelectedRowKeys(),
                success,
                error);
        } else {
            success();
        }
    }

    var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
                $scope.img.image = evt.target.result;
                $scope.model.smallImageUrl = null;
                if ($scope.model.smallImageData) {
                    $scope.model.smallImageData.delete = false;
                }
                     
            });
        };
        reader.readAsDataURL(file);
    };

    $timeout(function () {
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    }, 1000);

    $scope.onFranchiseAdd = function () {
        employeeSvc.initNewFranchisesLicense($scope.model);
    }

    $scope.onFranchiseRemove = function (franchise) {
        _.remove($scope.model.franchises, function (n) {
            return n === franchise;
        });
    }

}]);
